export default "__VITE_ASSET__00dfbc11__"